import {urlBase} from '../environment'

const urlBaseApi = `${urlBase}api/`; 
export const url_getCodiguera =`${urlBaseApi}gethomecodigueras`;
export const url_getMedicamentosByCountry = pais => `${urlBaseApi}gethomeproductsbycountry/${pais}`;
export const url_getmeddrahomebyllt = llt => `${urlBaseApi}getmeddrahomebyllt/${llt}`;

export const url_postreporthome= `${urlBaseApi}postreporthome`;
